import { Component, OnInit,Renderer2, Input, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import {ObservablesService} from '../observables.service';
import { Subject } from "rxjs";
import { DatePipe } from '@angular/common';
import { ExcelService } from "../excel.service"
import { Router } from '@angular/router';
import { _ } from 'underscore';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
@Component({
  selector: 'app-slip-view',
  templateUrl: './slip-view.component.html',
  styleUrls: ['./slip-view.component.scss']
})
export class SlipViewComponent implements OnInit {
  slips:any=[]
  parties:any=[]
  selectedItems: any = [];
  sum: number=0;
  selectedParty:any=null;
  selectedTag:any=null;
  selectedRangeDates:any=null;
  productSubscribeVariable:any;
  productObserver:any = new Subject<any>();
  sortStatus:boolean = false;
  menuVisible:boolean = false;
  slipPrintSubscriber:any;
  user_id:any;
  loggedUserInfo:any=[];
  invoiceSlipStatus:boolean = true;
  _selectedClient:any;
  displayedColumns: string[] = ['slip_date', 'slip_number' ,'business_name', 'total_amount', 'actions'];
  displayedColumns1: string[] = ['slip_date', 'slip_number' ,'invoice_date', 'invoice_number','business_name', 'total_amount', 'actions'];
  slipData:MatTableDataSource<any>;

 @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Input() set selectedLastClient(selectedClient){
    this._selectedClient =  selectedClient;
  }
  @Input() set selectedClient(selectedClient){
    // console.log("selectedClients==",selectedClient)
    this._selectedClient =  selectedClient;
  }


  @Input() set selectedData(selectedData){
    // console.log("party  date selected==",selectedData)
    if(selectedData === undefined){
    }else{
      this.selectedRangeDates = selectedData.selectedDates;
      this.selectedParty = (selectedData.selectedParty)?selectedData.selectedParty.id:null
      this.selectedTag = (selectedData.selectedTag)?selectedData.selectedTag.id:null
      if(this.selectedParty || this.selectedTag){

        if(this.selectedParty && this.selectedTag){
          this.getSlips(false,true,true)
        }else if(this.selectedParty && !this.selectedTag){
          this.getSlips(false,true,false)
        }else if(!this.selectedParty && this.selectedTag){
          this.getSlips(false,false,true)
        }else{
          this.getSlips(false)
        }

      }else if(!this.selectedParty || !this.selectedTag){
        if(!_.isEmpty(this._selectedClient)){
          this.getSlips(true)
        }else{
          this.getSlips(false)
        }
      }

    }
  }

  getSlips(client_status=false,party_status=false,tag_status=false){
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
        let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
        let conditions:any;
        let fields:any;
        let joins:any;

        if(client_status){

          if(!this.invoiceSlipStatus){
            fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
            conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id,"I.delete_status":0};
            joins = [
              {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
              {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]}
            ]
          }else{
            fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
            conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id};
            joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]

          }
        }else{

          if(party_status && tag_status){
            if(!this.invoiceSlipStatus){
              fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag, "I.delete_status":0};
              joins = [
                {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
                {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]},
                {type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},
                {type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}
              ]
            }else{

              fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag};
              joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
            }

          }else if(party_status && !tag_status){
            if(!this.invoiceSlipStatus){
              fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"I.delete_status":0};
              joins = [
                {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
                {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]}
              ]
            }else{
              fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id};
              joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
            }
          }else if(!party_status && tag_status){
            if(!this.invoiceSlipStatus){
              fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag,"I.delete_status":0};
              joins = [
                {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
                {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]},
                {type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},
                {type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}
              ]
            }else{
              fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag};
              joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
            }
          }else if(!party_status && !tag_status){
            // console.log("in else")
            if(!this.invoiceSlipStatus){
              fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id, "I.delete_status":0};
              joins = [
                {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
                {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]}
              ]
            }else{
              fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
              conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id};
              joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
            }
          }
        }


        this.api.send("findDb",{
          fields:fields,
          table:"master_slips as S",
          joins:joins,
          conditions:[conditions],
          order:"S.id DESC"
        }).then((res:any)=>{
          // console.log(res)
          this.slips=res.data;
          this.slipData = new MatTableDataSource(this.slips);
          this.slipData.sort = this.sort;
        })
      }else{
        this.api.logOut()
      }
    })

  }

constructor(private excelService:ExcelService,private router:Router,private renderer2:Renderer2, private elementRef:ElementRef,public datePipe:DatePipe, private api:ApiService, private observables:ObservablesService) { }


  ngOnInit() {
    this.observables.refreshSlipListStatus.subscribe(()=>{
      if(this.selectedParty || this.selectedTag){
        if(this.selectedParty && this.selectedTag){
          this.getSlips(false,true,true)
        }else if(this.selectedParty && !this.selectedTag){
          this.getSlips(false,true,false)
        }else if(!this.selectedParty && this.selectedTag){
          this.getSlips(false,false,true)
        }else{
          this.getSlips(false)
        }
      }else if(!this.selectedParty || !this.selectedTag){
        if(!_.isEmpty(this._selectedClient)){
          this.getSlips(true)
        }else{
          this.getSlips(false)
        }
      }
    })

  }

  getDisplayedColumns(){

    if(this.invoiceSlipStatus ){
      return this.displayedColumns
    }else{
      return this.displayedColumns1
    }
  }

  // getTagRelatedData(tagData){
  //   let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  //   let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
  //
  //   let conditions:any;
  //   let fields:any;
  //   let joins:any;
  //   fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //   joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
  //   conditions = {"S.invoice_status !":1,"S.business_id":this.loggedUserInfo.business_id, "ST.tag_id":tagData.id};
  //
  //   this.api.send("findDb",{
  //     fields:fields,
  //     table:"slips as S",
  //     joins:joins,
  //     conditions:[conditions],
  //     order:"S.id DESC"
  //   }).then((res:any)=>{
  //     // console.log(res)
  //     this.slips=res.data;
  //     // console.log("slips==",this.slips)
  //     this.slipData = new MatTableDataSource(this.slips);
  //     this.slipData.sort = this.sort;
  //   })
  // }



  // getDatewiseSlips(status = true,specific_status = false,allStatus = false){
  //   // console.log("specific_status=",specific_status)
  //   let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  //   let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
  //
  //   let conditions:any;
  //   let fields:any;
  //   let joins:any;
  //   if(status){
  //     if(specific_status && !allStatus){
  //       fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id};
  //       joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //
  //     }else if(specific_status && allStatus){
  //       fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id};
  //       joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //     }else{
  //
  //       fields=["false as checked_status, false as disabled_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id};
  //       joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //     }
  //   }else{
  //     if(allStatus){
  //
  //       fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"I.delete_status":0};
  //       joins = [
  //         {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
  //         {type:"left",table:"slip_invoices as SI",conditions:["SI.slip_id = S.id"]},
  //         {type:"left",table:"invoices as I",conditions:["I.id = SI.invoice_id"]}
  //       ]
  //     }else{
  //
  //       fields=["false as checked_status, false as disabled_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id,"I.delete_status":0};
  //       joins = [
  //         {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
  //         {type:"left",table:"slip_invoices as SI",conditions:["SI.slip_id = S.id"]},
  //         {type:"left",table:"invoices as I",conditions:["I.id = SI.invoice_id"]}
  //       ]
  //     }
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:fields,
  //     table:"slips as S",
  //     joins:joins,
  //     conditions:[conditions],
  //     order:"S.id DESC"
  //   }).then((res:any)=>{
  //     // console.log(res)
  //     this.slips=res.data;
  //
  //   })
  // }

  getGstInclusiveAmount(){
    return this.slips.reduce( ( accumulator, currentValue ) => {
      return accumulator +( currentValue.total_amount + currentValue.gst_total_amount);
    }, 0);
  }
  getGstExclusiveAmount(){
    return this.slips.reduce( ( accumulator, currentValue ) => {
      return accumulator + parseFloat(currentValue.total_amount);
    }, 0);
  }


  sortByDueDate(){
    this.sortStatus = !this.sortStatus;
    this.sortSlips();

  }



  sortSlips(){
    if(this.sortStatus){
      this.slips.sort(function(a, b) {
          var dateA:any = new Date(a.slip_date);
          var dateB:any = new Date(b.slip_date);
          return dateA - dateB;
      });
    }else{
      this.slips.sort(function(a, b) {
          var dateA:any = new Date(a.slip_date);
          var dateB:any = new Date(b.slip_date);
          return dateB - dateA;
      });
    }
    // this.slips.sort((a, b) => new Date(b.slip_date) - new Date(a.slip_date));

  }




slipToInvoice(){
  // this.observables.setPage({page:"slip-to-invoice",data:this.selectedItems})
  // console.log("selected slips==",this.selectedItems)
  if(this.selectedItems.length > 0){

    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/slip-to-invoice')],{ state: { data: this.selectedItems, user_id:this.selectedItems[0].user_id} });
  }
}


  search(slip, event, i) {
    // console.log(this.slips)
    if(this.selectedItems.length > 0){
      if(this.selectedItems[0].party_id == slip.party_id && this.selectedItems[0].direct_slip_status == slip.direct_slip_status){
        let index = this.selectedItems.indexOf(slip);
        if (event.target.checked) {
            if (index === -1) {
                this.selectedItems.push(slip);
                this.slips[i].checked_status = true;
            }
        } else {
            if (index !== -1) {
                this.selectedItems.splice(index, 1);
                this.slips[i].checked_status = false;
                if(this.selectedItems.length == 0){

                  this.enableAllCheckBoxes()
                }
            }
        }

      }else{

        if(event.target.checked){

          if(this.selectedItems[0].party_id != slip.party_id){

            this.observables.showToastMessage({type:1,message:'Selected Slips are not assigned to same Party..'});
          }else if(this.selectedItems[0].direct_slip_status != slip.direct_slip_status){

            this.observables.showToastMessage({type:1,message:'Both direct & detailed slips can not be selected..'});

          }

          this.slips[i].checked_status = false;
        }
      }

    }else{
      var index = this.selectedItems.indexOf(slip);
      if (event.target.checked) {
          if (index === -1) {
              this.selectedItems.push(slip);
              this.slips[i].checked_status = true;
              if(this.selectedItems.length == 1){

                this.disableUnrelatedCheckBoxes(slip)
              }
          }
      } else {
          if (index !== -1) {
              this.selectedItems.splice(index, 1);
              this.slips[i].checked_status = false;
          }
      }
    }
        // console.log("selected== ",this.selectedItems);
        // console.log("slips== ",this.slips);
    }

    disableUnrelatedCheckBoxes(slip){
      this.slips.map((item,i)=>{
        if(item.party_id !=slip.party_id || item.direct_slip_status != slip.direct_slip_status){
          this.slips[i].disabled_status = true;
        }
      })
    }
    enableAllCheckBoxes(){
      this.slips.map((item,i)=>{
        this.slips[i].disabled_status = false;
      })
    }

    viewSlip(slipData){
      this.observables.showSlipViewStatus.next({id:slipData.id,invoiceStatus:true,invoiceSlipStatus:this.invoiceSlipStatus})
    }



   editSlip(slip){
     this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/edit-slip')],{ state: { data: slip, editStatus:true} });
   }

   deleteSlip(slip,index){
     console.log("slips=",this.slips)
     console.log("index=",index)
     if(confirm("Are you sure to delete Slip no: "+slip.slip_number+" ?")){
       this.api.send("deleteDb",{
         table:"master_slips",
         conditions:[{id:slip.id}]
       }).then((deleteSlip:any)=>{
         if(deleteSlip.data.affectedRows){
            if(slip.direct_slip_status == 0){
              this.api.send("deleteDb",{
                  table:"categories",
                  conditions:[{slip_id:slip.slip_id}]
                }).then((deleteCat:any)=>{
                    if(deleteCat.data.affectedRows){

                      this.api.send("deleteDb",{
                        table:"master_slip_products",
                        conditions:[{master_slip_id:slip.id}]
                      }).then((deleteProd:any)=>{
                        if(deleteProd.data.affectedRows){
                          this.observables.showToastMessage({type:0,message:'Slip Deleted...'});
                          this.slips.splice(index, 1)
                          this.slipData = new MatTableDataSource(this.slips);
                          this.slipData.sort = this.sort;

                        }else{

                          this.observables.showToastMessage({type:0,message:'Slip Deleted...'});
                          this.slips.splice(index, 1)
                          this.slipData = new MatTableDataSource(this.slips);
                          this.slipData.sort = this.sort;
                        }

                      })
                    }else{
                       this.observables.showToastMessage({type:0,message:'Slip Deleted...'});
                       this.slips.splice(index, 1)
                       this.slipData = new MatTableDataSource(this.slips);
                       this.slipData.sort = this.sort;
                    }
                  })
                }else{

                  this.observables.showToastMessage({type:0,message:'Slip Deleted...'});
                  this.slips.splice(index, 1)
                  this.slipData = new MatTableDataSource(this.slips);
                  this.slipData.sort = this.sort;
                }
           }else{
             this.observables.showToastMessage({type:1,message:'Slip not Deleted, try again...'});
           }
       })
     }
   }


   viewInvoicedSlips(){
     this.invoiceSlipStatus = !this.invoiceSlipStatus;
     if(this.selectedParty || this.selectedTag){

       if(this.selectedParty && this.selectedTag){
         this.getSlips(false,true,true)
       }else if(this.selectedParty && !this.selectedTag){
         this.getSlips(false,true,false)
       }else if(!this.selectedParty && this.selectedTag){
         this.getSlips(false,false,true)
       }else{
         this.getSlips(false,false,false)
       }

     }else if(!this.selectedParty || !this.selectedTag){
       if(!_.isEmpty(this._selectedClient)){
         this.getSlips(true,false,false)
       }else{
         this.getSlips(false,false,false)
       }
     }

     this.observables.setInvoicedSlips.next()

   }

   exportAsXLSX():void {
     // console.log("response for popup-",this.slips)
     this.iterateData(this.slips).then((slipData:any)=>{
       console.log("response for popup-",slipData)
       this.excelService.exportAsExcelFile(slipData, 'slip');

     })
   }

   iterateData(data){
     return new Promise((resolve)=>{
       let a = 0
       let slipData:any=[]
       this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
         if(a>=data.length){
           this.productSubscribeVariable.unsubscribe()
           resolve(slipData)
         }else{
           this.api.send("findDb",{
            table:"master_slip_products",
            conditions:[{master_slip_id:data[a].id}]
          }).then((res:any)=>{
            if(res.data.length > 0){

              let groups = _.groupBy(res.data,"category_id")
              // console.log("master value==",_.values(groups));
              let values =_.values(groups)
              slipData.push({
                "Slip Date":this.datePipe.transform(data[a].slip_date, 'dd-MM-yyyy'),
                "Slip Number":data[a].slip_number,
                "Business Name":data[a].business_name,
                "Party Name":data[a].party_name,
                "GSTIN":data[a].gstin,
                "Taxable Amount":data[a].gst_total_amount,
                "Slip Amount(Ex. GST)":data[a].total_amount,
                "Slip Amount(In. GST)":data[a].gst_total_amount+data[a].total_amount,
              })
              for(let i=0;i<values.length;i++){
                slipData.push({"Category Name":values[i][0].category_name})

                for(let j=0;j<values[i].length;j++){
                  slipData.push({
                    "Item Name":values[i][j].item_name,
                    "Item description":values[i][j].item_description,
                    "Col_1_unit_variable":values[i][j].col_1,
                    "Col_1_unit_variable_value":values[i][j].col_1_value,
                    "Col_2_unit_variable":values[i][j].col_2,
                    "Col_2_unit_variable_value":values[i][j].col_2_value,
                    "Col_3_unit_variable":values[i][j].col_3,
                    "Col_3_unit_variable_value":values[i][j].col_3_value,
                    "Unit":values[i][j].unit,
                    "Unit Value":values[i][j].unit_value,
                    "Rate":values[i][j].rate,
                    "Discount":values[i][j].discount,
                    "Grass Amount":values[i][j].grass_amount,
                    "SGST":values[i][j].sgst,
                    "CGST":values[i][j].cgst,
                    "IGST":values[i][j].igst,
                    "Net Amount":values[i][j].net_amount
                  })

                  if(j == values[i].length-1){
                    // console.log("i==",i)
                    // console.log("j==",j)
                    this.productObserver.next(a+1)
                  }
                }
              }
            }else{
              // console.log("------------------------------------------------------",data[a].id)
              slipData.push({
                "Slip Date":this.datePipe.transform(data[a].slip_date, 'dd-MM-yyyy'),
                "Slip Number":data[a].slip_number,
                "Business Name":data[a].business_name,
                "Party Name":data[a].party_name,
                "GSTIN":data[a].gstin,
                "Taxable Amount":data[a].gst_total_amount,
                "Slip Amount(Ex. GST)":data[a].total_amount,
                "Slip Amount(In. GST)":data[a].gst_total_amount+data[a].total_amount,
                "Category Name":"-----No Data-----"
              })

              this.productObserver.next(a+1)
            }

          })
         }
       })

       this.productObserver.next(a)

     })
   }
}
